<div class="layout-container">
  <app-header (toggleSidenav)="toggleNav()"></app-header>

  <div class="body-row">
    <!-- ① Collapsible nav: icon strip always visible + full drawer overlays on expand -->
    <div class="nav-sidebar">
      <div class="icon-strip">
        <button class="strip-toggle" (click)="toggleNav()" [matTooltip]="navOpen ? 'Close menu' : 'Open menu'" matTooltipPosition="right">
          <mat-icon>{{ navOpen ? 'close' : 'menu' }}</mat-icon>
        </button>
        <nav class="strip-icons" [attr.aria-label]="'NAV.ICON_STRIP_LABEL' | translate">
          <a
            *ngFor="let item of navItems; trackBy: trackByRoute"
            [routerLink]="item.route"
            routerLinkActive="strip-active"
            class="strip-icon-item"
            [matTooltip]="item.label | translate"
            matTooltipPosition="right">
            <mat-icon>{{ item.icon }}</mat-icon>
          </a>
        </nav>
      </div>

      <div class="nav-drawer" [class.open]="navOpen">
        <div class="drawer-header">
          <button class="drawer-close" (click)="navOpen = false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <nav class="drawer-nav" [attr.aria-label]="'NAV.DRAWER_LABEL' | translate">
          <a
            *ngFor="let item of navItems; trackBy: trackByRoute"
            [routerLink]="item.route"
            routerLinkActive="drawer-active"
            class="drawer-item"
            (click)="navOpen = false">
            <mat-icon class="di">{{ item.icon }}</mat-icon>
            <span class="dl">{{ item.label | translate }}</span>
          </a>
        </nav>
      </div>

      <div class="nav-backdrop" [class.visible]="navOpen" tabindex="-1" (click)="navOpen = false" (keydown.escape)="navOpen = false"></div>
    </div>

    <!-- ② Main content area (includes fixed config panel inside each page) -->
    <div class="main-area">
      <router-outlet></router-outlet>
    </div>
  </div>

  <app-footer></app-footer>
</div>
